export default {
  "b2b.smlouvy-grid-columns.cislo.label": "Číslo",
  "b2b.smlouvy-grid-columns.popis.label": "Popis",
  "b2b.smlouvy-grid-columns.fixniMZO.label": "Fixní MZO",
  "b2b.smlouvy-grid-columns.fixniVZO.label": "Fixní VZO",
  "b2b.smlouvy-grid-columns.platnostOd.label": "Platnost od",
  "b2b.smlouvy-grid-columns.platnostDo.label": "Platnost do"
};
